import React from 'react';
import { withPrefix } from 'gatsby-link';

import $ from 'jquery';

import './_themes.scss';


class Themes extends React.Component {

  constructor(props) {
    super(props);
  }

  //==============
  // React Methods
  //==============

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  //=================
  // Render Component
  //=================

  render() {
    return (
      <section class="theme-cards-container">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="card card-theme">
              <img src={withPrefix('/images/themes/technology.jpg')} class="card-img-top" alt="Technology theme image" />
              <div class="card-body">
                <h5 class="card-title">Technology</h5>
                <p class="card-text">Invest your money towards the brands you rely on everyday. Add the most innovative companies to your portfolio including Apple, Facebook, Amazon and Google.</p>

                <div class="d-flex justify-content-between align-items-center">
                  <a class="cta-link" href="http://www.betashares.com.au/fund/nasdaq-100-etf/#each-overview" target="_blank">Learn more</a>
                  <span class="badge badge-light">Theme</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="card card-theme">
              <img src={withPrefix('/images/themes/ethical.jpg')} class="card-img-top" alt="Ethical theme image" />
              <div class="card-body">
                <h5 class="card-title">Ethical</h5>
                <p class="card-text">Invest where you know you are doing good (and as importantly, not doing harm). Add “Climate Leaders” from a broad range of global locations to your portfolio.</p>

                <div class="d-flex justify-content-between align-items-center">
                  <a href="http://www.betashares.com.au/fund/global-sustainability-leaders-etf/" class="cta-link" target="_blank">Learn more</a>
                  <span class="badge badge-light">Theme</span>
                </div>

              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="card card-theme">
              <img src={withPrefix('/images/themes/health.jpg')} class="card-img-top" alt="Health theme image" />
              <div class="card-body">
                <h5 class="card-title">Health</h5>
                <p class="card-text">Invest your money towards companies keeping us well. Add biotechnology, healthcare, medical equipment and pharmaceutical companies to your portfolio.</p>

                <div class="d-flex justify-content-between align-items-center">
                  <a href="https://www.blackrock.com/au/individual/products/273430/ishares-global-healthcare-etf" class="cta-link" target="_blank">Learn more</a>
                  <span class="badge badge-light">Theme</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="card card-theme">
              <img src={withPrefix('/images/themes/asia.jpg')} class="card-img-top" alt="Asia theme image" />
              <div class="card-body">
                <h5 class="card-title">Asia</h5>
                <p class="card-text">Invest towards large, established Asian companies listed in China, Hong Kong, Macau, Singapore, South Korea, and Taiwan.</p>

                <div class="d-flex justify-content-between align-items-center">
                  <a href="https://www.blackrock.com/au/individual/products/273416/ishares-asia-50-etf" class="cta-link" target="_blank">Learn more</a>
                  <span class="badge badge-light">Theme</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default Themes;





// WEBPACK FOOTER //
// ./src/components/Themes/index.js